// @flow

import type {
  RecommendationOperation,
} from 'hfty-operator-recommendations/types'

import type {
  Crop,
} from 'fc-model-crops/types'

// Libs
import React, { Component } from 'react'
import _find from 'lodash/find'
import _round from 'lodash/round'
import { FormattedMessage } from 'react-intl'

// messages
import {
  messages as recommendation_messages,
} from 'hfty-recommendations'

// utils
import traverse from 'fc-utils/traverse'
import { getCropUnit } from 'hfty-utils'

// Components
import { Errors } from 'hfty-components-errors'

// Constants
import {
  PROP_YIELD_TARGET,
  PROP_CONTROLLER_TYPE,
  PROP_CROP,
} from 'hfty-model-recommendations'

import {
  PROP_CROP_ID,
  PROP_NAME as PROP_CROP_NAME,
} from 'fc-model-crops'

// Components
import FormField from '@react-mdc/form-field'

// Styles
import { grey } from 'hfty-styles/src/colors'

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    color: grey(0.9),
    margin: '15px 10px',
    padding: '5px 10px',
    borderLeft: 'solid 3px red',
  },
  item: {
    margin: '5px 0',
  },
  title: {
    fontWeight: 500,
    marginRight: 5,
  },
}

type Props = {
  operation: RecommendationOperation,
  crops: Array<Crop>,
  currentUserUnits: string,
}

export default class DeleteRecommendation extends Component {
  props: Props

  render (): React.Element<any> {
    const { operation, currentUserUnits } = this.props
    const hasErrors = operation && operation.errors
    const crop = _find(this.props.crops, (crop: Crop): boolean => (
      crop[PROP_CROP_ID] === traverse(['model', PROP_CROP])(operation)
    ))
    const controllerType = traverse(['model', PROP_CONTROLLER_TYPE])(operation)
    const targetYield = traverse(['model', PROP_YIELD_TARGET])(operation)

    const cropUnit = getCropUnit(crop, currentUserUnits)

    return (
      <div style={styles.container}>
        <FormField>
          {hasErrors && <Errors errors={operation.errors} />}
        </FormField>
        <div style={styles.item}>
          <span style={styles.title}>
            <FormattedMessage {...recommendation_messages['AddRecommendation.crop']} />:
          </span>
          {crop[PROP_CROP_NAME]}
        </div>
        <div style={styles.item}>
          <span style={styles.title}>
            <FormattedMessage {...recommendation_messages['AddRecommendation.targetYield']} />:
          </span>
          <span style={{marginRight: 5}}>{_round(targetYield, 2)}</span>
          <FormattedMessage {...recommendation_messages[`AddRecommendation.${cropUnit}`]} />
        </div>
        <div style={styles.item}>
          <span style={styles.title}>
            <FormattedMessage {...recommendation_messages['AddRecommendation.controllerType']} />:
          </span>
          {controllerType}
        </div>
      </div>
    )
  }
}
